<template>
  <GenericStep v-bind="$attrs">
    <IncomeCard
      :item="peParty"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import IncomeCard from '@/components/Party/PartyEdit/SectionCards/BackgroundCards/IncomeCard.vue'

export default {
  name: 'IncomeStep',

  components: {
    GenericStep,
    IncomeCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return {
        children: this.peParty.children.map(c => pick(c, [
          'monthly_income',
          'income_verification',
        ])),

        marriages: this.peParty.spouses.map(s => pick(s, [
          'monthly_income',
          'income_verification',
        ])),

        parents: this.peParty.parents.map(p => pick(p, [
          'monthly_income',
          'income_verification',
        ])),

        party: pick(
          this.peParty, [
            'monthly_household_income_estimated',
            'monthly_income',
            'income_verification',
          ]
        ),

        siblings: this.peParty.siblings.map(s => pick(s, [
          'monthly_income',
          'income_verification',
        ])),
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
